var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "dailyReport-btn-container"
  }, [_c("div", {
    staticClass: "btn",
    on: {
      click: _vm.query
    }
  }, [_c("img", {
    attrs: {
      src: require("../image/largeWater/btn.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("生产日报")])]), _vm.pupopShow ? _c("div", {
    staticClass: "pupop"
  }, [_c("div", [_c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        _vm.pupopShow = false;
      }
    }
  }, [_vm._v("返回")]), _c("div", {
    staticClass: "btns"
  }, [_c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.dailyReports(0);
      }
    }
  }, [_vm._v("生成1池日报")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.dailyReports(1);
      }
    }
  }, [_vm._v("生成2池日报")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.dailyReports(2);
      }
    }
  }, [_vm._v("生成3池日报")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.dailyReports(3);
      }
    }
  }, [_vm._v("生成4池日报")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.dailyReports(4);
      }
    }
  }, [_vm._v("生成5池日报")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.dailyReports(5);
      }
    }
  }, [_vm._v("生成6池日报")])]), _c("div", {
    staticClass: "table"
  }, [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "reportDate",
      label: "生成时间",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.reportDate ? _vm.dayjs(scope.row.reportDate).format("YYYY-MM-DD HH:mm:ss") : "--"))])];
      }
    }], null, false, 4137803356)
  }), _c("el-table-column", {
    attrs: {
      prop: "question",
      label: "问题",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          staticStyle: {
            cursor: "pointer",
            color: "#2F9EFF"
          },
          on: {
            click: function click($event) {
              return _vm.look(scope.row.id);
            }
          }
        }, [_vm._v("查看检测报告")])];
      }
    }], null, false, 3099458157)
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  })], 1)])]) : _vm._e(), _vm.dialogShow ? _c("div", {
    staticClass: "pupop",
    staticStyle: {
      "z-index": "1000"
    }
  }, [_c("div", {
    staticClass: "dialog"
  }, [_c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        _vm.dialogShow = false;
      }
    }
  }, [_vm._v("关闭")]), _c("div", {
    staticClass: "dialog-content"
  }, _vm._l(_vm.reportDetail, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "question"
    }, [_c("div", {
      staticClass: "label"
    }, [_vm._v("问题：")]), _c("pre", [_vm._v(_vm._s(item[0]))])]), _c("div", {
      staticClass: "question"
    }, [_c("div", {
      staticClass: "label"
    }, [_vm._v("回答：")]), _c("pre", [_vm._v(_vm._s(item[1]))])])]);
  }), 0)])]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };